import React from "react";
import { useLoyalty } from "../../hooks/";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useHistory } from "react-router-dom";
import { StyledText } from "../common";
import useFastestFinger from "../../hooks/useFastestFinger";

const HomeCarousel = ({ setData }) => {
  const { fastestFingerData } = useFastestFinger();
  const { inCarousel, setSelectedEvent } = useLoyalty();

  const history = useHistory();

  const handleImageClick = (index, item) => {
    if (item.eventDetails) {
      setSelectedEvent(item.eventDetails);
    } else {
      setData(item);
    }

    if (item?.tag === "digital-skills-training") {
      history.push("/digital-skills-training");
      return;
    }

    if (item?.tag === "skills_academy") {
      window.open("https://skillsacademy.mtn.com", "_blank");
      return;
    }

    if (item?.title === "Capture & Share") {
      history.push("/capturenshare");
    } else if (item?.title === "Mashup & Win") {
      history.push("/mashupnwin");
    } else if (item?.title === "Ayoba") {
      history.push("/ayoba");
    } else if (item?.title === "Speed Shopping") {
      history.push("/speedshopping");
    } else if (item?.offerId === "movie_mania") {
      history.push("/loyalty/moviemania");
    } else if (item?.title === "Pulse & Chill") {
      history.push("/pulsenchill");
    } else if (item?.offerId === "dishrack") {
      history.push("/loyalty/dishrack");
    } else if (item?.offerId === "potbelly") {
      history.push("/loyalty/potbelly");
    } else if (item?.tag === "pulse_trivia") {
      history.push("/trivia/trivia-category");
    } else if (item?.isLoyalty) {
      history.push("/loyalty/loyaltydescription");
    } else if (item?.tag === "Mashup") {
      window.location.replace(item.url);
    } else if (item?.tag === "Event") {
      history.push("/loyalty/eventshome");
    } else if (item?.tag === "movie-mania-redemption") {
      history.push("/loyalty/moviemaniaredemption");
    } else if (item?.tag === "dishrack-redemption") {
      history.push("/loyalty/dishrackredemption");
    } else if (item?.tag === "potbelly-redemption") {
      history.push("/loyalty/potbellyredemption");
    } else if (item?.tag === "ypyc") {
      history.push("/ypycregistration");
    } else if (["past", "live"].includes(item.category)) {
      history.push("/loyalty/livestream");
    } else if (item?.tag === "fastestFinger") {
      history.push("/fastest_finger");
    } else if (item?.tag === "jumia") {
      history.push("/black-friday");
    } else if (item?.tag === "hunger_games") {
      history.push("/trivia/trivia-category?category=SPE-T");
    } else if (item?.tag === "spin_the_wheel") {
      history.push("/spin_the_wheel");
    } else if (item?.tag === "announcement") {
      history.push(`/loyalty/announcement?id=${item?.id}`);
    } else if (item?.tag === "digital-skills-training") {
      history.push("/digital-skills-training");
    } else if (item?.tag === "business-challenge") {
      history.push("/business_challenge");
    }
  };

  return (
    <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
      {[
        ...inCarousel,
        fastestFingerData
          ? {
              carouselImage: fastestFingerData?.imageUrl,
              tag: "fastestFinger",
            }
          : null,
      ]
        .filter((el) => el != null)
        .map((item, index) => (
          <div key={index} onClick={() => handleImageClick(index, item)}>
            <img
              alt="Carousel Offers"
              style={{ borderRadius: 10 }}
              width="100%"
              height="200px"
              src={item.carouselImage}
              size
            />
          </div>
        ))}
    </Carousel>
  );
};

export default HomeCarousel;
